import { Injectable } from "@angular/core";
import { ChecklistProgressStateStore } from "./checklist-progress-state.store";
import { Checklist, LocationActivity, Response } from "../checklist.interface";
import { UnsupportedQuestionsService } from "../services/unsupported-questions.service";

@Injectable({ providedIn: "root" })
export class ChecklistProgressStateService {
	constructor(
		private checklistProgressStateStore: ChecklistProgressStateStore,
		private unsupportedQuestionsService: UnsupportedQuestionsService,
	) {}

	clearProgress = () => {
		this.checklistProgressStateStore.store.reset();
	};

	setActiveChecklist = async (checklist: Checklist, activity: LocationActivity) => {
		this.checklistProgressStateStore.store.update((state) => {
			const newChecklist = state.checklist?.id !== checklist.id;
			checklist.started ??= new Date().toISOString();
			checklist.activity = activity;

			const responses = newChecklist ? [] : this.clearResponsesSetAsUnsupported(checklist, state.responses);

			return {
				checklist: checklist,
				currentPageIndex: newChecklist ? 0 : state.currentPageIndex,
				responses: responses,
			};
		});
	};

	private clearResponsesSetAsUnsupported = (checklist: Checklist, responses: Response[]): Response[] => {
		const responsesSetAsNotSupported = responses.filter(
			(response) =>
				response.answers.length == 1 &&
				response.answers[0] === UnsupportedQuestionsService.unsupportedAnswerValue,
		);

		if (responsesSetAsNotSupported.length === 0) {
			return responses;
		}
		// Flatten all checklist elements
		const checklistElements = checklist.pages.flatMap((page) => page.elements);

		// Find question IDs that are now supported
		const nowSupportedQuestionIds = responsesSetAsNotSupported
			.filter((notSupportedResponse) => {
				const element = checklistElements.find((element) => element.id === notSupportedResponse.question);
				return this.unsupportedQuestionsService.isElementSupported(element?.type);
			})
			.map((response) => response.question);

		// Return updated responses without unsupported questions
		return responses.filter((x) => nowSupportedQuestionIds.includes(x.question) === false);
	};

	setResponses = (responses: Response[]) => {
		this.checklistProgressStateStore.store.update((state) => {
			return { ...state, responses: responses };
		});
	};
}
